import React from "react";
import { Divider, Flex } from "@chakra-ui/react";
import { SideList } from "../IndividualSubmissionPage/SideList";
import { DataTable } from "../IndividualSubmissionPage/DataTable";

export const SummarySubmissionPage = ({
  submissions,
  selectSummarySubmission,
}) => {
  const tableHeaders = [
    { title: "Responder", flex: "flex3" },
    { title: "Response", flex: "flex3" },
    { title: "Points", flex: "flex1" },
  ];
  return (
    <Flex
      style={{
        maxWidth: "1180px",
        margin: "0 auto",
        padding: "0 20px 30px",
        minHeight: "calc(100vh - 116px)",
      }}
    >
      <SideList
        searchLabel="Search questions"
        type="questionList"
        listItems={submissions.summarySubmissions}
        onSelect={selectSummarySubmission}
        isFocusedId={submissions?.selectedSummarySubmission?.id}
      />
      <Divider orientation="vertical" minHeight="calc(100vh - 136px)" />
      <DataTable
        name={submissions?.selectedSummarySubmission?.name}
        tableData={submissions?.selectedSummarySubmission?.tableData}
        tableHeaders={tableHeaders}
        filterKeys={["responder", "response", "points"]}
        type="Summary"
      />
    </Flex>
  );
};
